import {
  Auth,
  Config,
  Installations,
  Products,
  Services,
  Vendor,
} from "@client-shared/providers";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/auth-context";
import { RoasterProfileProvider } from "./contexts/roaster-profile-context";
import "./styles/globals.css";

// Initialize i18n
import "@bcc/lib/i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Auth.SfdcAuthProvider>
          <Vendor.VendorProvider>
            <Services.ServicesProvider>
              <Config.ConfigProvider>
                <Installations.InstallationsProvider>
                  <Products.ProductsProvider>
                    <AuthProvider>
                      <RoasterProfileProvider>
                        <App />
                      </RoasterProfileProvider>
                    </AuthProvider>
                  </Products.ProductsProvider>
                </Installations.InstallationsProvider>
              </Config.ConfigProvider>
            </Services.ServicesProvider>
          </Vendor.VendorProvider>
        </Auth.SfdcAuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
